import { createRouter, createWebHashHistory } from "vue-router"


const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("../layout")
  },
  {
    path: "/school",
    name: "school",
    component: () => import("../layout/school")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../layout/login")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../layout/register")
  },
  {
    path: "/forgetpwd",
    name: "forgetpwd",
    component: () => import("../layout/forgetpwd")
  },
  {
    path: "/managelogin",
    name: "managelogin",
    component: () => import("../views/managelogin")
  },
  {
    path: "/manage",
    name: "manage",
    component: () => import("../views/manage"),
    children: [
      //首页echarts
      {
        path: "/manage/home",
        name: "home",
        component: () => import("../views/manage/home")
      },

      //基础信息管理baseinfo
      {
        path: "/manage/baseinfo/yhxx",
        name: "yhxx",
        component: () => import("../views/manage/baseinfo/yhxx")
      },
       //基础信息管理-班级信息
       {
        path: "/manage/baseinfo/classes",
        name: "classes",
        component: () => import("../views/manage/baseinfo/classes")
      },

      //基础信息管理baseinfo 教师
      {
        path: "/manage/baseinfo/yhxxJs",
        name: "yhxxJs",
        component: () => import("../views/manage/baseinfo/yhxxJs")
      },
       //基础信息管理baseinfo 学校
      {
        path: "/manage/baseinfo/yhxxXx",
        name: "yhxxXx",
        component: () => import("../views/manage/baseinfo/yhxxXx")
      },
      {
        path: "/manage/baseinfo/schools",
        name: "schools",
        component: () => import("../views/manage/baseinfo/schools")
      },
      // {
      //   path: "/manage/baseinfo/gwxx",
      //   name: "gwxx",
      //   component: () => import("../views/manage/baseinfo/gwxx")
      // },
      //课程信息管理 clazzinfo
      {
        path: "/manage/clazzinfo",
        name: "clazzinfo",
        component: () => import("../views/manage/clazzinfo"),
        children: [
          {//课程列表 我的课程
            path: "/manage/clazzinfo/list",
            name: "list",
            component: () => import("../views/manage/clazzinfo/list")
          },
          {//课程列表 本校课程
            path: "/manage/clazzinfo/listXx",
            name: "listXx",
            component: () => import("../views/manage/clazzinfo/listXx")
          },
          {//课程信息
            path: "/manage/clazzinfo/info",
            name: "info",
            component: () => import("../views/manage/clazzinfo/info")
          },
          {//课程学员
            path: "/manage/clazzinfo/member",
            name: "member",
            component: () => import("../views/manage/clazzinfo/member")
          },
          {//课程内容
            path: "/manage/clazzinfo/clazz",
            name: "clazz",
            component: () => import("../views/manage/clazzinfo/clazz")
          },
          {//预览练习
            path: "/manage/clazzinfo/clazz/prelianxi",
            name: "clazz/prelianxi",
            component: () => import("../views/manage/clazzinfo/clazz/prelianxi")
          },
          {//批改作业
            path: "/manage/clazzinfo/correct",
            name: "correct",
            component: () => import("../views/manage/clazzinfo/correct")
          },
          {//查看笔记
            path: "/manage/clazzinfo/note",
            name: "note",
            component: () => import("../views/manage/clazzinfo/note")
          },
          {//分句批改
            path: "/manage/clazzinfo/correctitem",
            name: "correctitem",
            component: () => import("../views/manage/clazzinfo/correctitem")
          },
          {//全文批改
            path: "/manage/clazzinfo/correcttask",
            name: "correcttask",
            component: () => import("../views/manage/clazzinfo/correcttask")
          },
          {//全文批改详情
            path: "/manage/clazzinfo/correcttaskdetail",
            name: "correcttaskdetail",
            component: () => import("../views/manage/clazzinfo/correcttaskdetail")
          },
          {//成绩统计 单元
            path: "/manage/clazzinfo/clazz/scoredanyuan",
            name: "clazz/scoredanyuan",
            component: () => import("../views/manage/clazzinfo/clazz/scoredanyuan")
          },
          {//成绩统计 练习
            path: "/manage/clazzinfo/clazz/scorelianxi",
            name: "clazz/scorelianxi",
            component: () => import("../views/manage/clazzinfo/clazz/scorelianxi")
          },
          {//成绩统计 课程
            path: "/manage/clazzinfo/clazz/scorekecheng",
            name: "clazz/scorekecheng",
            component: () => import("../views/manage/clazzinfo/clazz/scorekecheng")
          }
        ]
      },
      //语料信息管理 corpusinfo
      {
        path: "/manage/corpusinfo",
        name: "corpusinfo",
        component: () => import("../views/manage/corpusinfo")
        // children: [
        //   {//课程列表
        //     path: "/manage/corpusinfo/list",
        //     name: "corpusinfolist",
        //     component: () => import("../views/manage/corpusinfo/ListCorpus")
        //   },
        //   {//课程信息
        //     path: "/manage/clazzinfo/info",
        //     name: "corpusinfoadd",
        //     component: () => import("../views/manage/corpusinfo/AddCorpus")
        //   },
        //   {//课程学员
        //     path: "/manage/clazzinfo/member",
        //     name: "corpusinfoedit",
        //     component: () => import("../views/manage/corpusinfo/EditCorpus")
        //   }
        // ]
      },
      {
        path: "/manage/englishcet/cet",
        name: "englishcet/cet",//英语考试
        component: () => import("../views/manage/englishcet/cet")
      },
      {
        path: "/manage/englishcet/aicet",
        name: "englishcet/aicet",//英语考试
        component: () => import("../views/manage/englishcet/aicet")
      },
      {
        path: "/manage/englishcet/exam",
        name: "englishcet/exam",//英语考试
        component: () => import("../views/manage/englishcet/exam")
      },
      {
        path: "/manage/englishcet/train",
        name: "englishcet/train",//班级训练
        component: () => import("../views/manage/englishcet/train")
      },
      {
        path: "/manage/englishcet/statistics",
        name: "englishcet/statistics",//班级训练
        component: () => import("../views/manage/englishcet/statistics")
      },
      {
        path: "/manage/personalcenter/myinfo",
        name: "personalcenter/myinfo",//我的信息
        component: () => import("../views/manage/personalcenter/myinfo")
      },
      {
        path: "/manage/personalcenter/myclass",
        name: "personalcenter/myclass",//我的课程
        component: () => import("../views/manage/personalcenter/myclass"),
        children:[
          {
            path: "/manage/personalcenter/myclass/list",
            name: "personalcenter/myinfo/list",//我的课程列表
            component: () => import("../views/manage/personalcenter/myclass/list")
          },
          {
            path: "/manage/personalcenter/myclass/info",
            name: "personalcenter/myinfo/info",//我的课程信息
            component: () => import("../views/manage/personalcenter/myclass/info")
          },
          {
            path: "/manage/personalcenter/myclass/clazz",
            name: "personalcenter/myinfo/clazz",//我的课程内容
            component: () => import("../views/manage/personalcenter/myclass/clazz")
          },
          {
            path: "/manage/personalcenter/myclass/lianxi",
            name: "personalcenter/myinfo/lianxi",//开始练习
            component: () => import("../views/manage/personalcenter/myclass/lianxi")
          },
          {//答题预览
            path: "/manage/personalcenter/myclass/score",
            name: "/myclass/score",
            component: () => import("../views/manage/personalcenter/myclass/score")
          }
        ]
      },
      {
        path: "/manage/personalcenter/myexam",
        name: "personalcenter/myexam",//我的考试
        component: () => import("../views/manage/personalcenter/myexam")
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
